/** Must match V49__learning_demo_article.sql */
export const LEARNING_DEMO_ARTICLE_ID = 'a1b2c3d4-e5f6-4789-a012-3456789abcde'

export const LEARNING_DEMO_TARGET_WORD = 'curious'

export const LEARNING_DEMO_PARAGRAPH =
  'Emma is reading a book before school. She notices a curious word on the page and decides to learn it.'
